/**
 * Build a querystring from a params object, dropping empty values.
 *
 * Extracted from `hooks.ts` so resource definitions can share it: a resource
 * module importing from `hooks.ts` would invert the dependency, since hooks are
 * becoming thin wrappers over resources rather than the other way round.
 *
 * Empty string, null and undefined are all dropped, so an unset filter never
 * reaches the server as `?q=` — which several endpoints would treat as a real
 * (and unmatchable) search term.
 */
export function buildQs(q: object): string {
  const pairs = Object.entries(q).filter(
    (e): e is [string, string | number] => e[1] !== undefined && e[1] !== null && e[1] !== '',
  );
  if (!pairs.length) return '';
  const sp = new URLSearchParams();
  for (const [key, value] of pairs) sp.set(key, String(value));
  return `?${sp.toString()}`;
}
